import {Action, ActionReducerMap, createFeatureSelector, createSelector} from '@ngrx/store';

import * as actionsUi from './aufgabe.actions.ui';
import {Aufgabe, AufgabeDetail, Fehler, PhasenChecklistenAufgaben} from '../../../../clients/veranstaltungen';
import {
    GET_AUFGABE_DETAIL,
    GET_AUFGABE_DETAIL_ERFOLGREICH,
    GET_AUFGABE_DETAIL_FEHLER,
    GET_AUFGABE_FEHLER_ERFOLGREICH,
    GET_FUNKTIONSBEREICH_CHECKLISTEN_AUFGABEN,
    GET_FUNKTIONSBEREICH_CHECKLISTEN_AUFGABEN_ERFOLGREICH,
    GET_FUNKTIONSBEREICH_CHECKLISTEN_AUFGABEN_FEHLER,
    GetAufgabeDetailAction,
    GetAufgabeDetailErfolgreichAction,
    GetAufgabeDetailFehlerAction,
    GetAufgabeFehlerErfolgreichAction,
    GetFunktionsbereichChecklistenAufgabenAction,
    GetFunktionsbereichChecklistenAufgabenErfolgreichAction,
    GetFunktionsbereichChecklistenAufgabenFehlerAction,
    POST_AUFGABE_FREIGEBEN,
    POST_AUFGABE_FREIGEBEN_ERFOLGREICH,
    POST_AUFGABE_FREIGEBEN_FEHLER,
    POST_AUFGABE_NICHT_OK_ERFASSEN,
    POST_AUFGABE_NICHT_OK_ERFASSEN_ERFOLGREICH,
    POST_AUFGABE_NICHT_OK_ERFASSEN_FEHLER,
    POST_AUFGABE_OK_ERFASSEN,
    POST_AUFGABE_OK_ERFASSEN_ERFOLGREICH,
    POST_AUFGABE_OK_ERFASSEN_FEHLER,
    PostAufgabeNichtOkErfassenAction,
    PostAufgabeNichtOkErfassenErfolgreichAction,
    PostAufgabeNichtOkErfassenFehlerAction,
    PostAufgabeOkErfassenAction,
    PostAufgabeOkErfassenErfolgreichAction,
    PostAufgabeOkErfassenFehlerAction
} from '../../../../client-ngrx/veranstaltungen';
import { APP_RESET_ACTION } from '@orga-app/appstart/actions';
import {AKTUELLE_VERANSTALTUNG_SETZEN} from '../../app-state/actions/veranstaltung.actions';


export interface ModuleState {
    page: PageState;
}

export const reducers: ActionReducerMap<ModuleState> = {
    page: pageReducer
};

export interface PageState {
    phasenChecklistenAufgaben: Array<PhasenChecklistenAufgaben>;
    uiZeigeFbChecklistenAufgabenLaden: boolean;
    uiZeigeFbChecklistenAufgabenLadenFehler: boolean;

    aufgabeDetail: AufgabeDetail;
    aufgabeDetailLaden: boolean;
    aufgabeDetailLadeFehler: boolean;

    veranstaltungId: string;
    funktionsbereichId: string;
    checklisteId: string;
    aufgabeId: string;

    aufgabeNichtOkGemeldet: boolean;
    uiZeigeAufgabeNichtOkMeldenLaden: boolean;
    uiZeigeAufgabeNichtOkMeldenLadefehler: boolean;

    aufgabeOkGemeldet: boolean;
    uiZeigeAufgabeOkMeldenLaden: boolean;
    uiZeigeAufgabeOkMeldenLadefehler: boolean;

    aufgabeFreigebenGemeldet: boolean;
    uiZeigeAufgabeFreigebenMeldenLaden: boolean;
    uiZeigeAufgabeFreigebenMeldenLadefehler: boolean;

    fehler: Fehler;
}

export const initialPageState: PageState = {
    phasenChecklistenAufgaben: null,
    uiZeigeFbChecklistenAufgabenLaden: false,
    uiZeigeFbChecklistenAufgabenLadenFehler: false,

    aufgabeDetail: null,
    aufgabeDetailLaden: false,
    aufgabeDetailLadeFehler: false,

    veranstaltungId: null,
    funktionsbereichId: null,
    checklisteId: null,
    aufgabeId: null,

    aufgabeNichtOkGemeldet: false,
    uiZeigeAufgabeNichtOkMeldenLaden: false,
    uiZeigeAufgabeNichtOkMeldenLadefehler: false,

    aufgabeOkGemeldet: false,
    uiZeigeAufgabeOkMeldenLaden: false,
    uiZeigeAufgabeOkMeldenLadefehler: false,

    aufgabeFreigebenGemeldet: false,
    uiZeigeAufgabeFreigebenMeldenLaden: false,
    uiZeigeAufgabeFreigebenMeldenLadefehler: false,

    fehler: null
};

export function pageReducer(state = initialPageState, action: Action): PageState {
    switch (action.type) {
        // APP RESET
        case APP_RESET_ACTION: {
            return Object.assign({}, state, <PageState> initialPageState);
        }

        // Page State Reset
        case actionsUi.PAGE_STATE_RESET: {
            const a = <actionsUi.PageStateResetAction> action;

            return Object.assign({}, state, <PageState> initialPageState);
        }

        case AKTUELLE_VERANSTALTUNG_SETZEN: {
            return Object.assign({}, state, <PageState> initialPageState);
        }

        /* Aktuelle Id's setzen */
        case actionsUi.SETZE_VERANSTALTUNG_ID: {
            const a = <actionsUi.SetzeVeranstaltungIdAction> action;

            return Object.assign({}, state, <PageState> {
                veranstaltungId: a.veranstaltungId
            });
        }

        case actionsUi.SETZE_FUNKTIONSBEREICH_ID: {
            const a = <actionsUi.SetzeFunktionsbereichIdAction> action;

            return Object.assign({}, state, <PageState> {
                funktionsbereichId: a.funktionsbereichId
            });
        }

        case actionsUi.SETZE_CHECKLISTE_ID: {
            const a = <actionsUi.SetzeChecklisteIdAction> action;

            return Object.assign({}, state, <PageState> {
                checklisteId: a.checklisteId
            });
        }

        case actionsUi.SETZE_AUFGABE_ID: {
            const a = <actionsUi.SetzeAufgabeIdAction> action;

            return Object.assign({}, state, <PageState> {
                aufgabeId: a.aufgabeId
            });
        }

        // Aufgabe
        case GET_AUFGABE_DETAIL: {
            const a = <GetAufgabeDetailAction> action;

            return Object.assign({}, state, <PageState> {
                aufgabeDetailLaden: true
            });
        }

        case GET_AUFGABE_DETAIL_ERFOLGREICH: {
            const a = <GetAufgabeDetailErfolgreichAction> action;

            return Object.assign({}, state, <PageState> {
                aufgabeDetail: a.payload,
                aufgabeDetailLaden: false
            });
        }

        case GET_AUFGABE_DETAIL_FEHLER: {
            const a = <GetAufgabeDetailFehlerAction> action;

            return Object.assign({}, state, <PageState> {
                aufgabeDetail: null,
                aufgabeDetailLaden: false,
                aufgabeDetailLadeFehler: true
            });
        }


        // Funktionsbereich Checklisten Aufgaben
        case GET_FUNKTIONSBEREICH_CHECKLISTEN_AUFGABEN: {
            const a = <GetFunktionsbereichChecklistenAufgabenAction> action;

            return Object.assign({}, state, <PageState> {
                uiZeigeFbChecklistenAufgabenLaden: true
            });
        }

        case GET_FUNKTIONSBEREICH_CHECKLISTEN_AUFGABEN_ERFOLGREICH: {
            const a = <GetFunktionsbereichChecklistenAufgabenErfolgreichAction> action;

            return Object.assign({}, state, <PageState> {
                phasenChecklistenAufgaben: a.payload,
                uiZeigeFbChecklistenAufgabenLaden: false
            });
        }

        case GET_FUNKTIONSBEREICH_CHECKLISTEN_AUFGABEN_FEHLER: {
            const a = <GetFunktionsbereichChecklistenAufgabenFehlerAction> action;

            return Object.assign({}, state, <PageState> {
                phasenChecklistenAufgaben: [],
                uiZeigeFbChecklistenAufgabenLaden: false,
                uiZeigeFbChecklistenAufgabenLadenFehler: true
            });
        }

        /* OK MELDEN */
        case POST_AUFGABE_OK_ERFASSEN: {
            const a = <PostAufgabeOkErfassenAction> action;

            return Object.assign({}, state, <PageState> {
                aufgabeOkGemeldet: false,
                uiZeigeAufgabeOkMeldenLaden: true,
                uiZeigeAufgabeOkMeldenLadefehler: false
            });
        }

        case POST_AUFGABE_OK_ERFASSEN_ERFOLGREICH: {
            const a = <PostAufgabeOkErfassenErfolgreichAction> action;

            return Object.assign({}, state, <PageState> {
                aufgabeOkGemeldet: true,
                uiZeigeAufgabeOkMeldenLaden: false,
                uiZeigeAufgabeOkMeldenLadefehler: false
            });
        }

        case POST_AUFGABE_OK_ERFASSEN_FEHLER: {
            const a = <PostAufgabeOkErfassenFehlerAction> action;

            return Object.assign({}, state, <PageState> {
                aufgabeOkGemeldet: false,
                uiZeigeAufgabeOkMeldenLaden: false,
                uiZeigeAufgabeOkMeldenLadefehler: true
            });
        }


        /* NICHT OK MELDEN */
        case POST_AUFGABE_NICHT_OK_ERFASSEN: {
            const a = <PostAufgabeNichtOkErfassenAction> action;

            return Object.assign({}, state, <PageState> {
                aufgabeNichtOkGemeldet: false,
                uiZeigeAufgabeNichtOkMeldenLaden: true,
                uiZeigeAufgabeNichtOkMeldenLadefehler: false
            });
        }

        case POST_AUFGABE_NICHT_OK_ERFASSEN_ERFOLGREICH: {
            const a = <PostAufgabeNichtOkErfassenErfolgreichAction> action;

            return Object.assign({}, state, <PageState> {
                aufgabeNichtOkGemeldet: true,
                uiZeigeAufgabeNichtOkMeldenLaden: false,
                uiZeigeAufgabeNichtOkMeldenLadefehler: false
            });
        }

        case POST_AUFGABE_NICHT_OK_ERFASSEN_FEHLER: {
            const a = <PostAufgabeNichtOkErfassenFehlerAction> action;

            return Object.assign({}, state, <PageState> {
                aufgabeNichtOkGemeldet: false,
                uiZeigeAufgabeNichtOkMeldenLaden: false,
                uiZeigeAufgabeNichtOkMeldenLadefehler: true
            });
        }


        /* FREIGEBEN MELDEN */
        case POST_AUFGABE_FREIGEBEN: {
            const a = <PostAufgabeNichtOkErfassenAction> action;

            return Object.assign({}, state, <PageState> {
                aufgabeFreigebenGemeldet: false,
                uiZeigeAufgabeFreigebenMeldenLaden: true,
                uiZeigeAufgabeFreigebenMeldenLadefehler: false
            });
        }

        case POST_AUFGABE_FREIGEBEN_ERFOLGREICH: {
            const a = <PostAufgabeNichtOkErfassenErfolgreichAction> action;

            return Object.assign({}, state, <PageState> {
                aufgabeFreigebenGemeldet: true,
                uiZeigeAufgabeFreigebenMeldenLaden: false,
                uiZeigeAufgabeFreigebenMeldenLadefehler: false
            });
        }

        case POST_AUFGABE_FREIGEBEN_FEHLER: {
            const a = <PostAufgabeNichtOkErfassenFehlerAction> action;

            return Object.assign({}, state, <PageState> {
                aufgabeFreigebenGemeldet: false,
                uiZeigeAufgabeFreigebenMeldenLaden: false,
                uiZeigeAufgabeFreigebenMeldenLadefehler: true
            });
        }

        /* AUFGABE FEHLER */
        case GET_AUFGABE_FEHLER_ERFOLGREICH: {
            const a = <GetAufgabeFehlerErfolgreichAction> action;

            return Object.assign({}, state, <PageState> {
                fehler: a.payload
            });
        }

        default: {
            return state;
        }
    }
}


/**
 * The createFeatureSelector function selects a piece of state from the root of the state object.
 * This is used for selecting feature states that are loaded eagerly or lazily.
 */
export const getModuleState = createFeatureSelector<ModuleState>('AufgabePage');

export const getPageState = createSelector(getModuleState, (state: ModuleState) => state.page);

// DATA
export const getAufgabeNichtOkGemeldet = createSelector(getPageState, (state: PageState) => state.aufgabeNichtOkGemeldet);
export const getUiZeigeAufgabeNichtOkMeldenLaden = createSelector(getPageState, (state: PageState) => state.uiZeigeAufgabeNichtOkMeldenLaden);
export const getUiZeigeAufgabeNichtOkMeldenLadefehler = createSelector(getPageState, (state: PageState) => state.uiZeigeAufgabeNichtOkMeldenLadefehler);

export const getAufgabeOkGemeldet = createSelector(getPageState, (state: PageState) => state.aufgabeOkGemeldet);
export const getUiZeigeAufgabeOkMeldenLaden = createSelector(getPageState, (state: PageState) => state.uiZeigeAufgabeOkMeldenLaden);
export const getUiZeigeAufgabeOkMeldenLadefehler = createSelector(getPageState, (state: PageState) => state.uiZeigeAufgabeOkMeldenLadefehler);

export const getAufgabeFreigebenGemeldet = createSelector(getPageState, (state: PageState) => state.aufgabeFreigebenGemeldet);
export const getUiZeigeAufgabeFreigebenMeldenLaden = createSelector(getPageState, (state: PageState) => state.uiZeigeAufgabeFreigebenMeldenLaden);
export const getUiZeigeAufgabeFreigebenMeldenLadefehler = createSelector(getPageState, (state: PageState) => state.uiZeigeAufgabeFreigebenMeldenLadefehler);

export const getFehler = createSelector(getPageState, (state: PageState) => {
    if (state.aufgabeDetail !== null) {
        return state.aufgabeDetail.fehler;
    }
    return null;
});

export const getAufgabe = createSelector(getPageState, (state: PageState) => {

    if (state.aufgabeDetail !== null) {
        return state.aufgabeDetail.aufgabe;
    }
    return null;
});

export const getAufgabeDetail = createSelector(getPageState, (state: PageState) => {

    if (state.aufgabeDetail !== null) {
        return state.aufgabeDetail;
    }
    return null;
});
export const getAufgabeDetailLaden = createSelector(getPageState, (state: PageState) => state.aufgabeDetailLaden);
export const getAufgabeDetailLadefehler = createSelector(getPageState, (state: PageState) => state.aufgabeDetailLadeFehler);

export const getChecklisteStatus = createSelector(getPageState, (state: PageState) => {
    if (!state.phasenChecklistenAufgaben || state.phasenChecklistenAufgaben.length === 0 || !state.aufgabeId) {
        return null;
    }
    const cl = state.phasenChecklistenAufgaben
        .filter(item => item.checkliste.checkliste_id === state.checklisteId)
        .map(item => {
            let checklisteStatus = null;
            const res = item.phasen.forEach(phase => {
                if (phase.aufgaben.filter(auf => auf.aufgabe_id === state.aufgabeId).length === 0) {
                    return null;
                }
                checklisteStatus = phase.checkliste_status;
            });
            if (!checklisteStatus) {
                return null;
            }
            return checklisteStatus;
        })
        .filter(status => status !== null);
    if (cl.length === 0) {
        return null;
    }

    return cl.pop();
});


